import Vue from 'vue'
import Vuex from 'vuex'
import { appSettings } from './app_settings'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  appSettings: appSettings,
  userInfo: null
}

const store = new Vuex.Store({
  state,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js